"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileLogRestClient = void 0;
const authenticated_client_1 = require("./authenticated.client");
class MobileLogRestClient extends authenticated_client_1.AuthenticatedClient {
    constructor() {
        super(...arguments);
        this.basePath = 'mobile-log';
    }
    setListenerId(projectId, listenerId) {
        this.httpPut(`/${this.basePath}/projects/${projectId}/listeners/${listenerId}`);
    }
}
exports.MobileLogRestClient = MobileLogRestClient;
//# sourceMappingURL=mobile-log-rest.client.js.map